module.exports = __webpack_public_path__ + "static/media/gr6-quiz.77ffb72d.pdf";